// extracted by mini-css-extract-plugin
export default {"customHeader":"WebinarTabs_customHeader__D1OWK"};